import { Button } from "@shared/ui/button";
import { Card, CardContent } from "@shared/ui/card";
import { Link, useRouter } from "@tanstack/react-router";
import { ArrowLeft, FileQuestion, Home } from "lucide-react";
import { FormattedMessage } from "react-intl";

export default function NotFound() {
	const router = useRouter();

	const handleBack = () => {
		router.history.back();
	};

	return (
		<main className="flex flex-1 h-svh  items-center justify-center px-6 py-16">
			<Card className="w-full max-w-lg">
				<CardContent className="flex flex-col items-center px-8 py-12 text-center">
					<div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary">
						<FileQuestion className="h-8 w-8" />
					</div>
					<p className="text-sm font-medium text-primary">
						<FormattedMessage id="page.notFound.code" defaultMessage="404 error" />
					</p>
					<h1 className="mt-2 text-3xl font-semibold tracking-tight">
						<FormattedMessage id="page.notFound.title" defaultMessage="Page not found" />
					</h1>
					<p className="mt-3 max-w-sm text-sm text-muted-foreground">
						<FormattedMessage
							id="page.notFound.description"
							defaultMessage="The page you're looking for doesn't exist or has been moved. Check the URL or return to the dashboard."
						/>
					</p>
					<div className="mt-8 flex flex-col gap-2 sm:flex-row">
						<Button variant="outline" onClick={handleBack}>
							<ArrowLeft className="h-4 w-4" />
							<FormattedMessage id="page.notFound.back" defaultMessage="Back to last" />
						</Button>
						<Button asChild>
							<Link to="/">
								<Home className="h-4 w-4" />
								<FormattedMessage id="page.notFound.home" defaultMessage="Go home" />
							</Link>
						</Button>
					</div>
				</CardContent>
			</Card>
		</main>
	);
}
